export default "__VITE_ASSET__zl4uZ04l__"